import { get, post, put } from 'services/client';
import { apiEndpoints } from 'config';

export default {
  getPartners: async params => {
    const options = {
      url: apiEndpoints.partners,
      params: { ...params },
    };
    return get(options);
  },
  getPartnersNames: async params => {
    const options = {
      url: apiEndpoints.partnersNames,
      params: { ...params },
    };
    return get(options);
  },
  getLibraryPartners: async () => {
    const options = { url: apiEndpoints.partnersLibraryPartners };
    return get(options);
  },
  getPartner: async id => {
    const options = { url: apiEndpoints.partner.replace(':id', id) };
    return get(options);
  },
  createPartner: async data => {
    const options = { url: apiEndpoints.partners, data };
    return post(options);
  },
  updatePartner: async (data, id) => {
    const options = {
      url: apiEndpoints.partner.replace(':id', id),
      data,
    };
    return put(options);
  },
  approvePartners: async ids => {
    const options = {
      url: apiEndpoints.partnersApprove,
      data: { ids },
    };
    return put(options);
  },
  rejectPartners: async ids => {
    const options = { url: apiEndpoints.partnersReject, data: { ids } };
    return put(options);
  },
};
